var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 327 141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1895",
    "data-name": "Group 1895",
    transform: "translate(-369 -274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload_file_black_24dp",
    transform: "translate(484 274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8298",
    "data-name": "Path 8298",
    d: "M0,0H96.673V96.673H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8299",
    "data-name": "Path 8299",
    d: "M44.28,2H12.056A8.045,8.045,0,0,0,4.04,10.056L4,74.5a8.045,8.045,0,0,0,8.016,8.056H60.392A8.08,8.08,0,0,0,68.449,74.5V26.168ZM60.392,74.5H12.056V10.056h28.2V30.2h20.14ZM20.112,54.4l5.68,5.68,6.4-6.364V70.477h8.056V53.72l6.4,6.4,5.68-5.72L36.265,38.252Z",
    transform: "translate(12.112 6.056)",
    fill: "#aaa"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Drag_and_drop_documents_here",
    "data-name": "Drag and drop documents here",
    transform: "translate(369 410)",
    fill: "#aaa",
    fontSize: 24,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Drag and drop documents here")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.ec2a8b2dbb25794a4c297c2242319c3d.svg";
export { ForwardRef as ReactComponent };